module.exports = __webpack_public_path__ + "media/images/icons/truck-error-07baf19b6dd4ec49b91882e082b3499e.svg";